// extracted by mini-css-extract-plugin
module.exports = {"root":"filter-select-with-colored-icon_root__SNdyP"};